import { useMemo } from "react";
import { generatePath, Navigate } from "react-router";

import { getFirstDayOfMonth } from "@/lib/dayjs/get-first-day-of-month";
import { getLastDayOfMonth } from "@/lib/dayjs/get-last-day-of-month";
import { getTodaysDate } from "@/lib/dayjs/get-todays-date";

import { PATHS } from "@/routes/paths";

import { OptionStockManagementPresenter } from "./presenter";
import { useFetchOptionStock } from "../model/repository/query/use-fetch-option-stock";

type Props = {
	hotelID: string;
};

export const OptionStockManagementContainer = ({ hotelID }: Props) => {
	const todaysDt = useMemo(() => getTodaysDate(), []);
	const { startDt, endDt } = useMemo(() => {
		return {
			startDt: getFirstDayOfMonth({ date: todaysDt }),
			endDt: getLastDayOfMonth({ date: todaysDt }),
		};
	}, [todaysDt]);

	const { data: serverModel, onFetchOptionStock } = useFetchOptionStock({ hotelID, startDt, endDt });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<OptionStockManagementPresenter
			hotelID={hotelID}
			startDt={startDt}
			endDt={endDt}
			todaysDt={todaysDt}
			serverModel={serverModel}
			onFetchOptionStock={onFetchOptionStock}
		/>
	);
};

OptionStockManagementContainer.displayName = "OptionStockManagementContainer";
